export default __webpack_public_path__ + "static/media/orchid-houseplant.948ae366.jpg";